<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    :visible.sync="visible"
    width="330px">
    <auth-form title="登 录">
      <login-form @login="onLogin"/>
    </auth-form>
  </el-dialog>
</template>

<script>
import LoginForm from './LoginForm'
import AuthForm from './AuthForm'

export default {
  name: 'LoginDialog',
  components: {
    AuthForm,
    LoginForm,
  },
  data () {
    return {
      visible: false,
    }
  },
  created () {
  },
  methods: {
    open () {
      this.visible = true
    },
    onLogin () {
      this.visible = false
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    background-color: transparent;
    box-shadow: none;

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 0;
    }
  }
}
</style>
